import amica from './amica';

const carrier = process.env.REACT_APP_CARRIER_ID;

const config = {
    'am' : amica,
}

export default config[carrier]; 